import { api } from '../../lib/api.ts'
import { productionRecord, runEngineering, upload } from '../../modules/engineering/actions.ts'
import { proto } from './store.ts'

export interface EngineeringReworkRequest {
  id: string
  version: number
  orderId: string
  orderNumber: string
  productName: string
  section: string
  designerId: string
  designerName: string
  requestedById: string
  deadline: string
  reason: string
  fileName: string | null
  fileUrl: string | null
  actorName: string
  createdAt: string
  status: 'requested' | 'done' | 'cancelled'
}

/** Every rework request, resolved ones included. They arrive with the snapshot. */
export const engineeringReworks = () => proto.state.engineeringReworks
/** Requests still waiting for the engineer. */
export const engineeringReworkRequests = () =>
  engineeringReworks().filter((request) => request.status === 'requested')
export const reworkRequestsFor = (orderId: string) =>
  engineeringReworks().filter((request) => request.orderId === orderId)
export const addReworkRequest = (input: {
  orderId: string
  section: string
  designerId: string
  deadline: string
  reason: string
  file: File | null
}) =>
  runEngineering(async () => {
    const record = productionRecord(input.orderId),
      { file, ...body } = input
    await upload(
      '/engineering/rework',
      { ...body, orderId: record?.id ?? input.orderId, version: record?.version ?? 0 },
      file ? [file] : [],
      'POST',
    )
    return true
  }, false)
/** The engineer marks the rework done, or the person who asked calls it off. */
export const resolveRework = (request: EngineeringReworkRequest, status: 'done' | 'cancelled') =>
  runEngineering(async () => {
    await api(`/engineering/rework/${request.id}/resolve`, {
      method: 'POST',
      body: JSON.stringify({ id: request.id, version: request.version, status }),
    })
    return true
  }, false)
